import { Controller, useFormContext } from 'react-hook-form'

import { IMaskInput } from 'react-imask'
import classnames from 'classnames'
import { useRef } from 'react'
import { INVALID_PHONE_NUMBER_ERROR_MESSAGE } from '../../constants/messages'
import { isValidUSPhoneNumber } from '../../constants/schemaValidation'

type PhoneInputTypes = {
  error: boolean
  readOnly: boolean
}

const PhoneInput = ({ error, readOnly }: Readonly<PhoneInputTypes>) => {
  const ref = useRef(null)
  const { setError, clearErrors } = useFormContext()
  return (
    <Controller
      name="phoneNumber"
      render={({ field }) => (
        <IMaskInput
          mask={'(000) 000-0000'}
          unmask={false}
          overwrite={field?.value?.length === 14 ? true : 'shift'}
          inputMode="tel"
          className={classnames({
            error,
            'read-only': readOnly,
          })}
          type="tel"
          placeholder="(___) ___-____"
          data-testid="phone-number-input"
          id="phone-number-input"
          readOnly={readOnly}
          ref={ref}
          inputRef={(el) => {
            if (el) {
              field.ref(el)
            }
          }}
          name={field.name}
          value={field.value || ''}
          onAccept={(value: string) => {
            field.onChange(value)
          }}
          onBlur={async () => {
            field.onBlur()
            const isValid = await isValidUSPhoneNumber(field.value)
            if (!isValid) {
              setError('phoneNumber', {
                type: 'custom',
                message: INVALID_PHONE_NUMBER_ERROR_MESSAGE,
              })
            } else {
              clearErrors('phoneNumber')
            }
          }}
          autoComplete="tel-national"
        />
      )}
    />
  )
}
export default PhoneInput
